/**
 * Audytor Engine — TypeScript bundled entry point
 *
 * All engine modules are imported here and exposed to window
 * for backward compatibility with the inline React/Babel code in index.html.
 *
 * Build: `npm run build:engine` → public/audytor/engine.bundle.js (IIFE)
 */

import { TRANSLATIONS, t, getCurrentLang, setCurrentLang } from './translations';
import { ExcelProcessor, MONTH_SHORT, Helpers, ApiTransform, AuditDB } from './helpers';
import { SYSTEM_STYLES, SYSTEMS } from './systems';
import {
    RULE_LABELS, CATEGORY_BADGE_LABELS, CATEGORY_BADGE_COLORS,
    RULE_CATEGORIES, AUDIT_RULES, CATEGORY_WEIGHTS, runAudit, runAuditAsync,
} from './audit-rules';

// Re-export for ES module consumers
export * from './types';
export { TRANSLATIONS, t, getCurrentLang, setCurrentLang };
export { ExcelProcessor, MONTH_SHORT, Helpers, ApiTransform, AuditDB };
export { SYSTEM_STYLES, SYSTEMS };
export { RULE_LABELS, CATEGORY_BADGE_LABELS, CATEGORY_BADGE_COLORS, RULE_CATEGORIES, AUDIT_RULES, CATEGORY_WEIGHTS, runAudit, runAuditAsync };

// Assign to window for inline React/Babel code
const W = window as any;
W.TRANSLATIONS = TRANSLATIONS;
W.t = t;
W.getCurrentLang = getCurrentLang;
W.setCurrentLang = setCurrentLang;
W.currentLang = getCurrentLang();
W.ExcelProcessor = ExcelProcessor;
W.MONTH_SHORT = MONTH_SHORT;
W.Helpers = Helpers;
W.ApiTransform = ApiTransform;
W.AuditDB = AuditDB;
W.SYSTEM_STYLES = SYSTEM_STYLES;
W.SYSTEMS = SYSTEMS;
W.RULE_LABELS = RULE_LABELS;
W.CATEGORY_BADGE_LABELS = CATEGORY_BADGE_LABELS;
W.CATEGORY_BADGE_COLORS = CATEGORY_BADGE_COLORS;
W.RULE_CATEGORIES = RULE_CATEGORIES;
W.AUDIT_RULES = AUDIT_RULES;
W.CATEGORY_WEIGHTS = CATEGORY_WEIGHTS;
W.runAudit = runAudit;
W.runAuditAsync = runAuditAsync;
